const levels = {
  //first three levels are fixed winners.
  beginner: {
    1: {
      // range of number of dinos to be generated
      range: {
        low: 1,
        high: 1,
      },
      legends: {
        red: 5,
        blue: 11,
      },
    },
    2: {
      range: {
        low: 1,
        high: 3,
      },
      legends: {
        red: 4,
        blue: 9,
      },
    },
    3: {
      range: {
        low: 2,
        high: 2,
      },
      legends: {
        red: 3,
        blue: 14,
      },
    },
    4: {
      range: {
        low: 1,
        high: 4,
      },
      legends: {
        red: 1,
        blue: 10,
      },
    },
    5: {
      range: {
        low: 1,
        high: 4,
      },
      legends: {
        red: 8,
        blue: 11,
      },
    },
    6: {
      range: {
        low: 1,
        high: 4,
      },
      legends: {
        red: 7,
        blue: 12,
      },
    },
    7: {
      range: {
        low: 1,
        high: 4,
      },
      legends: {
        red: 6,
        blue: 13,
      },
    },
    8: {
      range: {
        low: 1,
        high: 4,
      },
      legends: {
        red: 5,
        blue: 14,
      },
    },
    9: {
      range: {
        low: 1,
        high: 4,
      },
      legends: {
        red: 4,
        blue: 15,
      },
    },
    10: {
      range: {
        low: 1,
        high: 4,
      },
      legends: {
        red: 3,
        blue: 16,
      },
      next: {
        difficulty: 'average',
        stage: '1',
      },
    },
  },
  average: {
    1: {
      range: {
        low: 1,
        high: 4,
      },
      legends: {
        red: 17,
        blue: 26,
      },
    },
    2: {
      range: {
        low: 1,
        high: 4,
      },
      legends: {
        red: 18,
        blue: 25,
      },
    },
    3: {
      range: {
        low: 1,
        high: 4,
      },
      legends: {
        red: 19,
        blue: 24,
      },
    },
    4: {
      range: {
        low: 1,
        high: 4,
      },
      legends: {
        red: 20,
        blue: 23,
      },
    },
    5: {
      range: {
        low: 1,
        high: 4,
      },
      legends: {
        red: 21,
        blue: 22,
      },
    },
    6: {
      range: {
        low: 2,
        high: 4,
      },
      legends: {
        red: 19,
        blue: 26,
      },
    },
    7: {
      range: {
        low: 2,
        high: 4,
      },
      legends: {
        red: 18,
        blue: 22,
      },
    },
    8: {
      range: {
        low: 1,
        high: 5,
      },
      legends: {
        red: 21,
        blue: 23,
      },
    },
    9: {
      range: {
        low: 1,
        high: 5,
      },
      legends: {
        red: 20,
        blue: 25,
      },
    },
    10: {
      range: {
        low: 2,
        high: 6,
      },
      legends: {
        red: 19,
        blue: 24,
      },
      next: {
        difficulty: 'hard',
        stage: '1',
      },
    },
  },
  hard: {
    1: {
      range: {
        low: 1,
        high: 1,
      },
      legends: {
        red: 27,
        blue: 36,
      },
    },
    2: {
      range: {
        low: 1,
        high: 3,
      },
      legends: {
        red: 28,
        blue: 35,
      },
    },
    3: {
      range: {
        low: 2,
        high: 2,
      },
      legends: {
        red: 29,
        blue: 34,
      },
    },
    4: {
      range: {
        low: 1,
        high: 4,
      },
      legends: {
        red: 30,
        blue: 33,
      },
    },
    5: {
      range: {
        low: 1,
        high: 4,
      },
      legends: {
        red: 31,
        blue: 32,
      },
    },
    6: {
      range: {
        low: 2,
        high: 4,
      },
      legends: {
        red: 29,
        blue: 36,
      },
    },
    7: {
      range: {
        low: 2,
        high: 4,
      },
      legends: {
        red: 28,
        blue: 32,
      },
    },
    8: {
      range: {
        low: 1,
        high: 5,
      },
      legends: {
        red: 31,
        blue: 33,
      },
    },
    9: {
      range: {
        low: 1,
        high: 5,
      },
      legends: {
        red: 27,
        blue: 35,
      },
    },
    10: {
      range: {
        low: 2,
        high: 6,
      },
      legends: {
        red: 30,
        blue: 34,
      },
      next: null,
    },
  },
};

export default levels;
